import { StyleSheet } from 'aphrodite';
import { destructive, titles } from '../../styles/colors';
import { baseStyleSheet } from '../../styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		background: '#FFE7EA',
		border: `2px solid ${destructive}`,
		boxSizing: 'border-box',
		color: titles,
		...baseStyleSheet.fontBold,
		fontSize: 14,
		minHeight: 30,
		paddingLeft: 40,
		paddingTop: 4,
		width: '100%',
	},
});
